import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/location-groups/')({
  beforeLoad: () => {
    throw redirect({ to: '/warehouses', replace: true });
  },
});
